import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { articlePath } from "@/lib/api";
import { BrandImg, TimeTag } from "./NewsCard";

export function Slider({ items }) {
  const [i, setI] = useState(0);
  const n = items.length;
  useEffect(() => {
    if (n < 2) return;
    const t = setInterval(() => setI((x) => (x + 1) % n), 6000);
    return () => clearInterval(t);
  }, [n, i]);
  if (!n) return null;
  const go = (d) => setI((x) => (x + d + n) % n);
  return (
    <section data-testid="home-slider" className="group relative overflow-hidden rounded-xl bg-black">
      <div className="flex transition-transform duration-700 ease-out" style={{ transform: `translateX(-${i * 100}%)` }}>
        {items.map((a, k) => (
          <Link key={a.id} to={articlePath(a)} data-testid={`slide-${k}`} className="relative block aspect-video w-full shrink-0">
            <BrandImg a={a} w={1200} />
            <span className="sr-only">{a.title}</span>
            <span className="absolute bottom-3 right-3 rounded-full bg-black/60 px-3 py-1 backdrop-blur"><TimeTag a={a} light /></span>
          </Link>
        ))}
      </div>
      <button data-testid="slider-prev-btn" onClick={() => go(-1)} aria-label="Anterior" className="absolute left-3 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-black/50 text-white opacity-0 backdrop-blur transition-opacity group-hover:opacity-100"><ChevronLeft /></button>
      <button data-testid="slider-next-btn" onClick={() => go(1)} aria-label="Seguinte" className="absolute right-3 top-1/2 grid h-10 w-10 -translate-y-1/2 place-items-center rounded-full bg-black/50 text-white opacity-0 backdrop-blur transition-opacity group-hover:opacity-100"><ChevronRight /></button>
      <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-1.5">
        {items.map((a, k) => <button key={a.id} data-testid={`slider-dot-${k}`} onClick={() => setI(k)} aria-label={`Slide ${k + 1}`} className={`h-1.5 rounded-full transition-all ${k === i ? "w-6 bg-primary" : "w-1.5 bg-white/60"}`} />)}
      </div>
    </section>
  );
}
